const typeUrlPrefix = 'type.googleapis.com';

type GetTypeUrl = (packageName: string, eventName: string) => string;
export const getTypeUrl: GetTypeUrl = (packageName, eventName) => `${typeUrlPrefix}/${packageName}.${eventName}`;
